import { useEffect, useState } from 'react';
// @ts-ignore
import Text from '../../Base/Text/Text';
import 'react-datepicker/dist/react-datepicker.css';
// @ts-ignore
import styles from './Select.module.scss';
import apiClient from '../../../Services/ApiClient';
import { TERM_ITEMS } from '../../../Modules/Term/termItems.graphql';
import { useEffectAsync } from '../../../helpers';
import Select, { SelectValue } from '../Select/Select';
import FormControl from '../../Form/FormControl';
import { useAppContext } from '../../../Services/AppContext';
import FormContainer from '../../Form/FormContainer';
import * as React from 'react';
import AsyncSelect from '../Select/AsyncSelect';
import DiagnosisSelect from './DiagnosisSelect';

interface DiagnosisLatamProps {
	onChange?: (values: DiagnosisLatamValues) => void;
	showTypeSelection?: boolean;
	value?: DiagnosisLatamValues;
}

export interface DiagnosisLatamValues {
	code?: string;
	codeLabel?: string;
	type?: string;
}

const DiagnosisLatam: React.FC<DiagnosisLatamProps> = props => {
	const { onChange, showTypeSelection = true, value } = props;

	const { translation } = useAppContext();
	const [tempValue, setTempValue] = useState<DiagnosisLatamValues>(
		value || {
			code: undefined,
			codeLabel: undefined,
			type: undefined,
		},
	);

	const handleChangeCode = (val: SelectValue) => {
		setTempValue(prev => {
			return { ...prev, code: val.value };
		});
		setTempValue(prev => {
			return { ...prev, codeLabel: val.label };
		});
	};

	const handleChangeType = (val: SelectValue) => {
		setTempValue(prev => {
			return { ...prev, type: val.value };
		});
	};

	useEffect(() => {
		onChange?.(tempValue);
	}, [tempValue]);

	return (
		<div className='d-flex flex-row align-items-center' style={{ gap: '15px' }}>
			<div className='flex-grow-1'>
				<DiagnosisSelect
					onChange={handleChangeCode}
					value={
						value?.code
							? { value: value.code, label: value.codeLabel }
							: undefined
					}
					placeholder={value?.codeLabel}
				/>
			</div>
			{showTypeSelection && (
				<Select
					placeholder={translation['base.shared.pick']}
					options={[
						{ value: 'presumptive', label: 'Presuntivo' },
						{ value: 'definitive', label: 'Definitivo' },
						{ value: 'repetitive', label: 'Repetitivo' },
						{ value: 'resolved', label: 'Resuelto' },
					]}
					onChange={handleChangeType}
					value={value?.type}
				/>
			)}
		</div>
	);
};

export default DiagnosisLatam;
